import * as React from 'react';

export interface IErrorProps {
    errorText: string;
}

export class SearchError extends React.Component<IErrorProps, any> {
    render() {
        return (
            <div className="block">
                <div className="block-inner">
                    <div className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.errorText }} />
                </div>
            </div>
        );
    }
}